import styled from 'styled-components';

export const PageContainer = styled.div`
  min-height: 100vh;
  background: #010606;
`;

export const HeroImageSection = styled.section`
  padding: 100px 24px 48px;
  max-width: 900px;
  margin: 0 auto;
`;

export const HeroImageWrap = styled.div`
  width: 100%;
  min-height: 280px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  margin-bottom: 8px;
  background: rgba(255, 255, 255, 0.05);
`;

export const HeroImage = styled.img`
  width: 100%;
  height: auto;
  min-height: 280px;
  display: block;
  object-fit: cover;
  max-height: 380px;
`;

export const ImageCaption = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  text-align: center;
`;

export const MainSection = styled.section`
  padding: 32px 24px 80px;
  max-width: 800px;
  margin: 0 auto;
  color: #fff;
`;

export const PageTitle = styled.h1`
  font-size: 40px;
  line-height: 1.2;
  font-weight: 600;
  color: #f7f8fa;
  margin-bottom: 32px;

  @media screen and (max-width: 480px) {
    font-size: 28px;
  }
`;

export const PageParagraph = styled.p`
  font-size: 18px;
  line-height: 1.7;
  color: #f0f0f0;
  margin-bottom: 24px;
`;

export const StepTitle = styled.h2`
  font-size: 22px;
  font-weight: 600;
  color: #01bf71;
  margin: 32px 0 12px 0;
`;

export const StepBlock = styled.div`
  margin-bottom: 40px;
`;

export const StepImageWrap = styled.div`
  width: 100%;
  max-width: 560px;
  min-height: 200px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  margin: 16px 0 20px 0;
  background: rgba(255, 255, 255, 0.05);
`;

export const StepImage = styled.img`
  width: 100%;
  height: auto;
  min-height: 200px;
  display: block;
  object-fit: cover;
  max-height: 280px;
`;

export const BackLink = styled.a`
  color: #01bf71;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 32px;
  display: inline-block;
  &:hover {
    text-decoration: underline;
  }
`;
